
  import { defineComponent } from "vue"

  import { getAdvisorImage } from "@/core/helpers/getAdvisorImage"

  import { PhoneIcon, MailIcon } from "@heroicons/vue/solid"

  export default defineComponent({
    name: 'OmAdvisorBox',

    props: ['advisor'],

    components: {
      PhoneIcon,
      MailIcon
    },

    methods: {
      getAdvisorImage
    }
  })
